import { css as o } from "@microsoft/fast-element";
import { normalize as t } from "../common/normalize.js";
import { display as l } from "@matrix42/fast-foundation";
const i = o`
  ${t}
  ${l("flex")}
  :host {
    /* Base */
    flex-direction: column;
  }

  .tablist {
    /* Layout */
    display: flex;
  }

  .tabpanel {
    /* Layout */
    display: flex;
  }
`;
export {
  i as tabsStyles
};
